import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { BreakdownFollowingService } from '../../../../../services/table-management/breakdownFollowing.service';
import { Rest } from '../../../../../../../rest/rest_client';
import { NotificationsService } from '../../../../../../../services/notifications-service/notifications.service';
import { I18nService } from '../../../../../../../services/i18n/i18n.service';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from '../../../../../../../core/services/authentication/authentication.service';
import { EntityFormComponent } from 'app/components/entity-form/entity-form.component';
import { UserTimePipe } from 'app/components/shared/UserTimePipe';

@Component({
  selector: 'app-breakdown-following-form',
  templateUrl: './breakdown-following-form.component.html',
  styleUrls: ['./breakdown-following-form.component.css'],
  providers: [BreakdownFollowingService],
  standalone: false,
})
export class BreakdownFollowingFormComponent extends EntityFormComponent<Rest.InvBreakdownFollowing> implements OnInit {
  active: boolean;
  title: string;
  formManipulation: boolean;
  disableGranted: boolean;
  ids: number [] = [];
  vehicleQualityCommitmentDate: Date;
  vehicleRentingDate: Date;
  replacementVehicleCollectionDate: Date;
  replacementVehicleReturnDate: Date;

  @Input() breakdown: Rest.InvBreakdown;

  constructor(
    private breakdownFollowingService: BreakdownFollowingService,
    notificationsService: NotificationsService,
    protected i18n: I18nService,
    private authenticationService: AuthenticationService,
    public translateService: TranslateService,
    protected userTime: UserTimePipe
  ) {
    super(breakdownFollowingService, notificationsService, i18n, authenticationService);
  }

  /**
   * Loads and evaluates all the necessary data before showing the form.
   *
   * @memberof AccessoryFormComponent
   */
  beforeShow() {
    this.active = !this.entity.disabled;
    this.ids = [];
    if (this.isNew) {
      this.title = this.translateService.instant('tableManagement.breakdown.breakdownFollowing.createBreakdownFollowing');
    } else {
      this.title = this.translateService.instant('tableManagement.breakdown.breakdownFollowing.updateBreakdownFollowing');
    }

    if (this.entity.documents && this.entity.documents.length > 0) {
			this.entity.documents.forEach((x) => this.ids.push(x.id));
		} else {
			this.ids = [-1];
		}

    if(this.breakdown){
      this.entity.breakdown = this.breakdown;
    }

    this.vehicleQualityCommitmentDate = this.entity.vehicleQualityCommitmentDate ? this.userTime.utcToCalendarDate(this.entity.vehicleQualityCommitmentDate) : null;
		this.vehicleRentingDate = this.entity.vehicleRentingDate ? this.userTime.utcToCalendarDate(this.entity.vehicleRentingDate) : null;
		this.replacementVehicleCollectionDate = this.entity.replacementVehicleCollectionDate ? this.userTime.utcToCalendarDate(this.entity.replacementVehicleCollectionDate) : null;
		this.replacementVehicleReturnDate = this.entity.replacementVehicleReturnDate ? this.userTime.utcToCalendarDate(this.entity.replacementVehicleReturnDate) : null;


    this.setPermissions();
  }

  setPermissions() {
    const user = this.authenticationService.user;
    const rolesForForm = ['INV_FOLLOWING_BREAKDOWN_CREATE', 'INV_FOLLOWING_BREAKDOWN_UPDATE'];

    this.formManipulation = this.authenticationService.isOneRoleGranted(rolesForForm, user);
    this.disableGranted = this.authenticationService.isRoleGranted("INV_FOLLOWING_BREAKDOWN_DISABLE", user);

  }

  protected beforeSave(): void {
		this.entity.vehicleQualityCommitmentDate = this.vehicleQualityCommitmentDate != null ? new Date(this.userTime.toUTCISOString(this.vehicleQualityCommitmentDate)): null;
		this.entity.vehicleRentingDate = this.vehicleRentingDate != null ? new Date(this.userTime.toUTCISOString(this.vehicleRentingDate)): null;
		this.entity.replacementVehicleCollectionDate = this.replacementVehicleCollectionDate != null ? new Date(this.userTime.toUTCISOString(this.replacementVehicleCollectionDate)): null;
		this.entity.replacementVehicleReturnDate = this.replacementVehicleReturnDate != null ? new Date(this.userTime.toUTCISOString(this.replacementVehicleReturnDate)): null;

	}

  saveChanges() {


    this.beforeSave();


      if (this.isNew) {

        this.breakdownFollowingService.create(this.entity).then((p) => {
          this.entity= p;
          //this.display = false;
          this.isNew = false;
          this.return.emit(p);
        });
      } else {

        this.breakdownFollowingService.update(this.entity).then((p) => {
          this.display = false;
          this.return.emit(p);
        });
      }
    
  }


}